import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Props } from "./Navbar.config";
import classes from "./Navbar.module.scss";

const Navbar: React.FC<Props> = ({ onMenuClick }) => {
  const [selected, setSelected] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const tab = tabs.find((tab) => tab.link === path);
    setIsSidebarOpen(false);
    if (tab) {
      setSelected(tab.name);
    } else if (path.includes("/temaDetay")) {
      setSelected("Temalar");
    } else if (path.includes("/projeDetay")) {
      setSelected("Projeler");
    } else if (path.includes("/birlikteGuzellestirelimDetay")) {
      setSelected("İzmir’i Birlikte Güzelleştirelim");
    } else if (path === "/") {
      setSelected("Anasayfa");
    } else {
      setSelected("");
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node) &&
        !(event.target as Element).closest(`.${classes.hamburger}`)
      ) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const tabs = [
    {
      name: "Hakkımızda",
      link: "/hakkimizda",
    },
    {
      name: "Temalar",
      link: "/temalar",
    },
    {
      name: "Projeler",
      link: "/projeler",
    },
    {
      name: "İzmir’i Birlikte Güzelleştirelim",
      link: "/birlikteGuzellestirelim",
    },
    {
      name: "İletişim",
      link: "/iletisim",
    },
  ];

  const clickedHandler = (name: string, tablink: string) => {
    setSelected(name);
    navigate(tablink);
    console.log(tablink);
  };

  return (
    <nav className={classes.navbar}>
      <div className={classes.leftSection}>
        <div className={classes.logo}>
          <img
            src="/assets/Logo.png"
            alt="İzmir Logo"
            onClick={() => clickedHandler("Anasayfa", "/")}
          />
        </div>
        <div
          className={classes.hamburger}
          onClick={() => setIsSidebarOpen(true)}
        >
          <img src="/assets/hamburger.png" alt="Hamburger" />
        </div>
      </div>
      <div className={classes.middleSection}>
        <ul className={classes.navLinks}>
          {tabs.map((tab) => (
            <li
              key={tab.name}
              className={selected === tab.name ? classes.active : ""}
              onClick={() => clickedHandler(tab.name, tab.link)}
            >
              {tab.name}
            </li>
          ))}
        </ul>
      </div>
      <div className={classes.rightSection}>
        <img
          src="/assets/ibb-logo.png"
          alt="Büyükşehir Logo"
          onClick={() => window.open("https://www.izmir.bel.tr/", "_blank")}
        />

        <img
          src="/assets/egesehir-logo.png"
          className={classes.ege}
          alt="Egesehir Logo"
          onClick={() => window.open("https://www.egesehir.com.tr", "_blank")}
        />
      </div>
      <div
        className={classes.blur}
        style={{ display: isSidebarOpen ? "block" : "none" }}
      >
        <div className={classes.sidebar} ref={sidebarRef}>
          <div className={classes.x} onClick={() => setIsSidebarOpen(false)}>
            <img src="/assets/hamburgerx.png" alt="X" />
          </div>
          <div className={classes.sidebarContent}>
            <ul>
              {tabs.map((tab) => (
                <li
                  key={tab.name}
                  className={selected === tab.name ? classes.active : ""}
                  onClick={() => clickedHandler(tab.name, tab.link)}
                >
                  {tab.name}
                </li>
              ))}
            </ul>
            <div className={classes.sidebarBottom}>
              <img
                src="/assets/ibb-logo.png"
                alt="Büyükşehir Logo"
                onClick={() =>
                  window.open("https://www.izmir.bel.tr/", "_blank")
                }
              />
              <img
                src="/assets/egesehir-logo.png"
                className={classes.ege}
                alt="Egesehir Logo"
                onClick={() =>
                  window.open("https://www.egesehir.com.tr", "_blank")
                }
              />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
